import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center" data-testid="notfound-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-24 w-full">
        <div className="text-xs uppercase tracking-[0.22em] text-ember font-accent font-semibold">
          404
        </div>
        <h1 className="font-serif text-5xl md:text-6xl mt-4 text-ink leading-tight tracking-tight">
          We couldn&rsquo;t find that page.
        </h1>
        <p className="mt-5 text-lg text-ink-muted max-w-xl leading-relaxed">
          It may have moved, or the link may be wrong. You can return to the home page or take a look at our guides.
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="inline-flex items-center gap-2 bg-river text-linen px-6 py-3 text-sm font-accent font-semibold tracking-wide hover:bg-river-dark transition-colors"
          >
            Back to home
          </Link>
          <Link
            to="/understanding"
            data-testid="notfound-understanding-link"
            className="inline-flex items-center gap-2 border border-ink/30 text-ink px-6 py-3 text-sm font-accent font-semibold tracking-wide hover:bg-linen-alt transition-colors"
          >
            Understanding the system
          </Link>
        </div>
      </div>
    </div>
  );
}
